import { compose, mdsWidget } from 'dojo/_base/declare';
import lang from 'dojo/_base/lang';
import on from 'dojo/on';
import domConstructTyped from 'dojo/dom-construct';
import domAttr from 'dojo/dom-attr';
import domClass from 'dojo/dom-class';
import domStyle from 'dojo/dom-style';
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import HintBox from '../../../moreCore/UI/HintBox/HintBox';
import RoomDialog from './SelectRoomDialog/SelectRoomDialog';
import OccurrenceSKCaddons from './OccurrenceSKCaddons';
import template from './OccurrenceForm.html?raw';
// Template-only widgets (used via data-dojo-type in OccurrenceForm.html, not as values in code) → bare imports.
import "../../../moreCore/UI/EntityBased/EntitySelect/EntitySelect";
import "./OccurrencePropertiesTable";
import "./OccurrenceTaskList";
import "./OccurrenceCommentsList";
import "./OccurrenceNotesList";
import "./OccurrenceChildList";
// NOTE (JS2TS): dropped dead deps: dojo/aspect, dojo/number (not used); and DateDialog, DateTimeDialog,
// moreCore/UI/GenericDialog/GenericDialog (imported but never used in code and not referenced in the template).
// DOM-heavy → dom-construct aliased.
const domConstruct: any = domConstructTyped;

class OccurrenceForm extends compose(_WidgetBaseSP) {
    [key: string]: any;

    templateString: any = template;

    entityID: any = null;
    entityGUID: any = null;
    jsonEntity: any = null; // Entity wies aus der Datenbank kommt
    mainOccurrence: any = { ID: null };
    continuousSaveMode = false; // wenn true werden Datenänderungen immer gleich in die Datenbank zurückgespielt
    isDirty = false;
    _formDataUndirty: any = null;

    _skcData: any = null;

    selectedRoomID: any = null;
    selectedLevelID: any = null;
    selectedBuildingID: any = null;
    selectedBuildingPartID: any = null;
    isAreaNeeded: any = false;
    additionalLocations: any = [];

    isExternalEmployee = false;

    isSpecialConfirmationNeeded = false;
    _specialConfirmationStatus: any = null;

    startupState = "new";

    errorCallback: any = null;
    successCallback: any = null;

    propertyTable: any = null;
    occurrenceTypesData: any = null;

    employee: any = null;
    currentReporterEntity: any = null;
    _tmpSelectedReporterEntity: any = null;
    _tmpReporterHintbox: any = null;
    _enableChangeReporter = false;
    _isEditor = false;

    readonly: any = false;

    // Objekt mit Werten die beim Speichern übergeben werden (live / immer aktuell)
    formData: any = {
        _dataFormatVersion: 3, // falls die API auf eine neue Version reagieren muss während Updates!
        buildingID: null,
        buildingPartID: null,
        roomID: null,
        levelID: null,
        additionalLocations: [],
        reporterID: null,
        costCenterID: null,
        occurrenceTypeID: null,
        dateOfRecord: null,
        isEscalation: null,
        comment: null,
        specialConfirmation: null,
        propertyData: null, // Tabulator, alt, blöd, buuhh!
        properties: null, // neue Tabelle ab 2021!!
        mainOccurrenceID: null,
        _propertyAttributeHelper: "value_text_global" // temporär! wir müssen von value_text auf _global umschalten und die API kennt sich sonst nicht aus...
    };

    postMixInProperties(): void {
        super.postMixInProperties.apply(this, arguments as any);
    }
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
        this.RequestManager.silentExceptions = true;


        this.inputOccurrenceType.requestUrlParameter = "jsonParameters";
        let parameter: any = {};
        if ((window as any).occurrenceSubstitution) {
            parameter.ldapsubstitutionID = (window as any).occurrenceSubstitution.ID;
        }

        this.inputOccurrenceType.requestUrlParameterValue = JSON.stringify(parameter);

    }

    _setReadonlyAttr(value?: any): void {
        if (value != true && value != false) {
            value = this.readonly;
        }
        this.readonly = value;
        //console.log("setreadonly", value);

        //  Eskalationscheckbox
        // Sonderregeln, werden in der API gesteuert
        var allowEscalation: any = false;
        //if (this.jsonEntity != null) {
        //    allowEscalation = this.jsonEntity.canEscalate == true;
        //}
        if (allowEscalation === true) {
            //console.debug("allow escalation");
            domAttr.remove(this.inputEscalation, "disabled");
        } else {
            //console.debug("disable escalation");
            domAttr.set(this.inputEscalation, "disabled", !allowEscalation);
        }

        // Reporter editierbar?
        this._setEditReporterVisibility();

        this._setDIYvisibility();

        // zusätzliche Locations wählbar?
        var occurrenceType = null;
        if (this.jsonEntity != null) {
            occurrenceType = this.jsonEntity.ref_occurrence_type;
        }
        this._setAdditionalLocationsVisibility(occurrenceType);


        //if (this.readonly == true) {
        //    domClass.add(this.btnSendNote, "w3-hide");
        //} else {
        //    domClass.remove(this.btnSendNote, "w3-hide");
        //}

        //  Raumauswahl
        //
        if (this.buttonSelectRoom != null) {
            domAttr.set(this.buttonSelectRoom, "disabled", this.readonly);
            var domClassFct = this.readonly == true ? domClass.remove : domClass.add;
            domClassFct(this.buttonSelectRoom, "mds-hover-bright");

            var domClassFct = this.readonly == true ? domClass.add : domClass.remove;
            domClassFct(this.buttonSelectRoom, "w3-disabled");
            //domAttr.set(this.buttonSelectRoom, "disabled", this.readonly);
        }

        //  Anmerkung
        //
        if (this.inputComment != null) {
            domAttr.set(this.inputComment, "disabled", this.readonly);
        }

        //  Kostenstelle
        //
        this.inputCostCenter.set("readonly", true); // JDM: immer schreibgeschützt
        //if (this.inputCostCenter != null) {
        //    this.inputCostCenter.set("readonly", this.readonly);
        //}

        //  Meldungsart
        //
        if (this.inputOccurrenceType != null) {
            this.inputOccurrenceType.set("readonly", this.readonly || this.jsonEntity != null);
        }

        // Property Table
        //
        if (this.propertyTable != null && this.jsonEntity != null) {
            //domStyle.set(this.propertyTable.element, "pointerEvents", this.readonly == true ? "none" : ""); // tabulator hat kein readonly. darum über pointer-events alle klickts unterbinden

            this.propertyTable.updateOrAddData(this.jsonEntity.EL_property_occurence_assignment_occurrence);

            //this._renderPropertiesTable(this.jsonEntity.EL_property_occurence_assignment_occurrence);
        }
    }

    tableSelectableCheck(row: any): any {
        return !this.readonly;
    }

    _serializeDataHandle: any = null;
    serializeData_delayed(resetDirtyState?: any, bypassReadonly?: any): void {
        if (this._serializeDataHandle != null) {
            clearTimeout(this._serializeDataHandle);
            this._serializeDataHandle = null;
        }

        this._serializeDataHandle = setTimeout(lang.hitch(this, this.serializeData, resetDirtyState, bypassReadonly), 150);
    }

    serializeData(resetDirtyState?: any, bypassReadonly?: any): void {

        if (this._serializeDataHandle != null) {
            clearTimeout(this._serializeDataHandle);
            this._serializeDataHandle = null;
        }
        //dateOfRecord wird einmal direkt gesetzt und kann/darf sich nicht ändern
        //selbiges für reporterID - UPDATE: Reporter ist änderbar



        var entity = this.inputOccurrenceType.getValue();
        this.formData.occurrenceTypeID = (entity != null ? entity.ID : null);

        entity = this.inputCostCenter.get("value");
        this.formData.costCenterID = (entity != null ? this.PitHelper.getEntityAttributeValue(entity, "ID", "json") : null);

        //if (this.isAreaNeeded === true)
        this.formData.buildingID = this.selectedBuildingID;
        this.formData.buildingPartID = this.selectedBuildingPartID;
        this.formData.roomID = this.selectedRoomID;
        this.formData.levelID = this.selectedLevelID;

        this.formData.additionalLocations = [];
        for (var i = 0; i < this.additionalLocations.length; i++) {
            var addLoc = this.additionalLocations[i];

            this.formData.additionalLocations.push(addLoc.data);
        }


        this.formData.specialConfirmation = this._specialConfirmationStatus;
        this.formData.isDIY = this.inputDIY.checked;

        if (this.currentReporterEntity != null) {
            this.formData.reporterID = this.currentReporterEntity.ID;
        }

        this.formData.isEscalation = this.inputEscalation.checked;

        //this.formData.propertyData = (this.propertyTable != null ? this.propertyTable.getData() : null);
        this.formData.properties = this.propertiesTable._jsonDataOut;

        this.formData.comment = this.inputComment.value;

        this.formData.mainOccurrenceID = this.mainOccurrence ? this.mainOccurrence.ID : "";

        //if (this.SKCaddons) {
        //    this.formData.SKC = this.SKCaddons.getValue();
        //} else if (this.formData.SKC) {
        //    this.formData.SKC = null;
        //}

        if (resetDirtyState === true) {
            this._formDataUndirty = JSON.stringify(this.formData)
            //console.log("reset dirtystate", this._formDataUndirty);
        }

        console.log("serializeData", this.formData, "readonly?", this.readonly);

        if (this.readonly == true && bypassReadonly !== true) { // nicht weitermachen wenns schreibgeschützt ist!
            return;
        }

        if (this._formDataUndirty != null) {
            this.set("IsDirty", this._formDataUndirty != JSON.stringify(this.formData));
        } else {
            this.set("IsDirty", this._formDataUndirty == null && this.formData != null);
        }

        this.checkMandatoryFields();

        //console.log("serializeData - dirty?", this.formData, this.isDirty);

        if (this.isDirty === true && this.continuousSaveMode === true && this.startupState == "ready") {
            this.saveOccurrenceData();
        }
    }

    checkMandatoryFields(): any {
        //if (this.inputComment.value == null || this.inputComment.value == "") {
        //    domClass.add(this.inputComment, "w3-pale-red w3-border-red w3-text-red");
        //    return false;
        //} else {
        //    domClass.remove(this.inputComment, "w3-pale-red w3-border-red w3-text-red");
        //}

        return true;
    }

    _prepareSKCAddons(bHasRole?: any): void {
        //console.log("_prepareSKCAddons", bHasRole, this.jsonEntity.SKCdata);
        domConstruct.empty(this.skcAddonsContainer);

        if (!bHasRole) {

            domClass.add(this.sectionSKC, "w3-hide");
            this.SKCaddons = null;
        } else {
            this.SKCaddons = new OccurrenceSKCaddons();
            this.SKCaddons.placeAt(this.skcAddonsContainer);
            if (this.jsonEntity && this.jsonEntity.SKCdata) {
                this.SKCaddons.setFormData(this.jsonEntity.SKCdata);
            }
            domClass.remove(this.sectionSKC, "w3-hide");

            on(this.SKCaddons, "change", lang.hitch(this, this._onChangeSKC));
        }
    }

    _onChangeSKC(data?: any): void {
        let bDirtySKC = this.SKCaddons.checkDirty();

        //console.debug("_onChangeSKC", bDirtySKC, data);

        let enabledClasses = "mds-hover-bright";
        let disabledClasses = "w3-disabled w3-gray";

        let fctDisabled: any = domClass.add;
        let fctEnabled: any = domClass.remove;

        if (bDirtySKC) {
            fctDisabled = domClass.remove;
            fctEnabled = domClass.add;
        }

        fctDisabled(this.btnSkcSave, disabledClasses);
        fctEnabled(this.btnSkcSave, enabledClasses + " w3-green");

        fctDisabled(this.btnSkcUndo, disabledClasses);
        fctEnabled(this.btnSkcUndo, enabledClasses + " w3-red");
    }

    _onClick_SKCUndo(evt?: any): void {
        if (this.SKCaddons && this.SKCaddons.checkDirty() === true) {
            this.SKCaddons.setFormData(this.jsonEntity.SKCdata);
            this._onChangeSKC();
        }
    }

    _onClick_SKCSave(evt?: any): void {
        if (this.SKCaddons && this.SKCaddons.checkDirty() === true) {
            this.saveSKCdata();
        }
    }

    saveSKCdata(): void {

        if (!this.SKCaddons) return;

        this.StandbyStart(this.sectionSKC);

        let data = { "occurrenceID": this.entityID, skcData: this.SKCaddons.getValue() };

        //console.log("saveSKCdata", data);

        var url = window.appRoot + "Occurrence/SaveSKCData";

        this.RequestManager.callfunction(
            "Webtool_Occurrence_API__SaveSKCdata",
            data,
            lang.hitch(this, this._onSaveSKCDataResponse),
            lang.hitch(this, this._onSaveSKCDataError),
            true // commit
        );
    }

    _onSaveSKCDataResponse(response?: any): void {
        this.StandbyStop();
        this.SKCaddons.checkDirty(true);
        this._onChangeSKC();
    }

    _onSaveSKCDataError(error: any): void {
        this.StandbyStop();
        alert(error.Message);
        console.error("error saving skc data", error.Message);
    }

    startup(bReload?: any): void {

        //console.log("occurrenceform startup", this.entityID, this.entityGUID, this.jsonEntity, this.startupState);
        on(this.taskList, "ExecutersChanged", lang.hitch(this, "_onChanged_TaskExecuters"));
        on(this.commentsList, "CommentSaved", lang.hitch(this.taskList, "loadScheduledTaskExecutors"));

        this.inputCostCenter.set("readonly", true); // JDM: Kostenstelle immer schreibschützen

        //this.additionalLocations = [];
        this.removeAdditonalLocation();

        this.loadCurrentEmployee();

        // falls Datensatz geöffnet wird: laden
        if (this.entityGUID != null && this.jsonEntity == null ||
            this.entityGUID != null && this.jsonEntity != null && bReload === true) {
            this.startupState = "load";
            this.loadOccurrence();
        }
        // neuer Datensatz
        else {
            this.setDate();

            this.inputOccurrenceType._loadListValues();
            this.StandbyStop();

            this.startupState = "ready";
        }

        //this.inputOccurrenceType.

        //domClass.remove(this.actionContainer, "w3-hide");

    }

    loadCurrentEmployee(): void {
        this._isEditor = false;
        this.inputReporter.value = this.translations["OccurrenceForm__ReporterLabelDefault"];//"(ich)";

        if (this.employee != null) {
            this._onGetcurrentEmployee(this.employee);
            return;
        }

        var url = window.appRoot + "JDM/GetCurrentEmployeeJSON";

        this.RequestManager.post(
            url,
            {},
            lang.hitch(this, this._onGetcurrentEmployee),
            lang.hitch(this, function (error: any) {
                console.error("current employee fehler", error);
            }),
            false
        );
    }

    _onGetcurrentEmployee(response: any): void {
        this.employee = response;
        this.isExternalEmployee = this.employee.Classname == "Contact_person";
        this.taskList.isExternalEmployee = this.isExternalEmployee;
        for (var i = 0; i < response.groupList.length; i++) {
            var group = response.groupList[i];

            if (group.is_occurrence_group == true) {
                this._isEditor = true;
                break;
            }
        }

        this._setEditReporterVisibility();
        this._setDIYvisibility();
        this._setCostCenterVisibility();

        if (this.entityGUID != null && this.jsonEntity == null ||
            this.entityGUID != null && this.jsonEntity != null) {

        }
        // neuer Datensatz
        else {
            this._setReporterEntity(response);
        }
    }

    _setAdditionalLocationsVisibility(occurrenceType?: any): void {
        var bAllowMultipleLocations = false;

        //console.log("_setAdditionalLocationsVisibility", occurrenceType, "readonly?", this.readonly);

        domClass.add(this.selectAdditionalLocationsContainer, "w3-hide");

        if (typeof (occurrenceType) != "undefined" && occurrenceType != null && this.readonly != true) {
            if (occurrenceType.is_multiple_locations_selectable === true) {
                domClass.remove(this.selectAdditionalLocationsContainer, "w3-hide");
                bAllowMultipleLocations = true;
            }
        }

        if (bAllowMultipleLocations != true) {
            domClass.add(this.sectionAdditionalLocation, "w3-hide");
        } else {
            domClass.remove(this.sectionAdditionalLocation, "w3-hide");
        }
    }

    addLocation(locationEntity: any, label: any, existingOccurrenceID?: any, existingOccurrenceLabel?: any, existingOccurrenceColor?: any): void {

        //console.log("addLocation", locationEntity, label, existingOccurrenceID, existingOccurrenceLabel);

        if (locationEntity == null || typeof (locationEntity) == "undefined") {
            return;
        }

        // ein neues "Deskriptorobjekt" machen
        // bestehend aus der gewählten Location, vorhandene Meldung und dem HTML-Node

        // prüfen obs das schon gibt!
        var existingLoc = this._getAdditionalLocationById(locationEntity.ID);
        if (existingLoc != null) return; // nicht weitermachen!!

        var addLoc: any = {
            data: {
                locationEntity: locationEntity,
                occurrenceID: null
            },
            occurrenceLabel: null,
            node: null
        };

        if (existingOccurrenceID != null && typeof (existingOccurrenceID) != "undefined") {
            addLoc.data.occurrenceID = existingOccurrenceID;
            addLoc.occurrenceLabel = existingOccurrenceLabel;
        }

        var locButton = domConstruct.create("button");
        domClass.add(locButton, "mds-button-base round w3-margin-right w3-margin-bottom");
        domAttr.set(locButton, "innerHTML", label);

        if (addLoc.data.occurrenceID != null) {
            domClass.add(locButton, "mds-hover-bright");
            domStyle.set(locButton, "backgroundColor", existingOccurrenceColor.BackColor.Hex);
            domAttr.set(locButton, "innerHTML", label + " (" + addLoc.occurrenceLabel + ")");
            domAttr.set(locButton, "textDecoration", "none");
            //domAttr.set(locButton, "href", window.appRoot + "home/Occurrence/view?id=" + addLoc.data.occurrenceID);
            domAttr.set(locButton, "target", "_blank");

            var icon = domConstruct.create("i");
            domClass.add(icon, "fas fa-eye");
            //domStyle.set(icon, "display", "none");
            domStyle.set(icon, "marginLeft", "6px");
            domConstruct.place(icon, locButton);

        } else {
            domClass.add(locButton, "w3-hover-red w3-light-gray mds-hover-bright hover-strike");

            var icon = domConstruct.create("i");
            domClass.add(icon, "fas fa-times-circle w3-text-red");
            //domStyle.set(icon, "display", "none");
            domStyle.set(icon, "marginLeft", "6px");
            domConstruct.place(icon, locButton);
        }

        addLoc.node = locButton;

        domConstruct.place(locButton, this.additionalLocationsContainer);

        on(locButton, "click", lang.hitch(this, this._onClick_AdditionalLocation, addLoc))

        this.additionalLocations.push(addLoc);
    }

    _onClick_AdditionalLocation(locationDescriptor: any): void {
        //console.log("_onClick_AdditionalLocation", locationDescriptor);

        if (this.readonly == true) return;

        if (locationDescriptor.data.occurrenceID == null) {
            this.removeAdditonalLocation(locationDescriptor.data.locationEntity.ID);
            this.serializeData();
        } else {
            (document as any).occurrenceHome.showOccurrenceDialog(locationDescriptor.data.occurrenceID, false);
        }
    }

    _onClick_SelectAdditionalLocation(evt?: any): void {
        if (this.readonly == true) return;

        this.selectAdditionalRoom();
    }

    selectAdditionalRoom(): void {
        var roomDialog = new RoomDialog();
        roomDialog.set("callback", lang.hitch(this, "onSelectAdditionalRoom"));
        //roomDialog.returnCompleteEntities = true;
        roomDialog.set("NeededLayers", this.isAreaNeeded)

        roomDialog.selection.level = null;
        roomDialog.selection.building = null;
        roomDialog.selection.buildingpart = null;
        roomDialog.selection.room = null;

        roomDialog.set("ok", true);
        roomDialog.set("cancel", true);
        roomDialog.set("header", /*"Raum bearbeiten"*/this.translations["SelectRoomDialog__Header"]);


        roomDialog.show();
    }

    onSelectAdditionalRoom(result: any, selection: any): void {
        //console.info("onSelectAdditionalRoom", result, selection, this.additionalLocations);

        if (result != 1) {
            return;
        }

        var locationEntity: any = null;
        var label = selection._label;

        if (selection.room != null) {
            locationEntity = { ID: selection.room };
        }

        else if (selection.level != null) {
            // das is dermassen beshit!!
            // bei ZAL wird nicht das Stockwerk ausgewählt, sondern nur der StockwerksNAME
            // erst in Kombination mit dem Gebäudeteil kann das Backend sich daraus das wirkliche Stockwerk suchen!!
            // d.h. hier unbedingt "level"-ID + buildingpart mitgeben!!
            locationEntity = { ID: selection.level + ";" + selection.buildingpart };
        }

        else if (selection.buildingpart != null) {
            locationEntity = { ID: selection.buildingpart };
        }

        else if (selection.building != null) {
            locationEntity = { ID: selection.building };
        }

        else {
            return;
        }

        locationEntity.targettype = selection.targettype;

        this.addLocation(locationEntity, label)

        if (this.startupState == "ready") {
            this.serializeData();
        }
    }

    removeAdditonalLocation(targetID?: any): void {
        if (typeof (targetID) == "undefined") {
            targetID = null;
        }

        //console.log("removeAdditonalLocation", targetID, this.additionalLocations);

        var index = null;

        if (targetID != null) {
            index = this._getAdditionalLocationIndexById(targetID);
        }

        for (var i = 0; i < this.additionalLocations.length; i++) {
            if (index == null || index == i) {
                domConstruct.destroy(this.additionalLocations[i].node);
                if (index != null) {
                    this.additionalLocations.splice(i, 1);
                }
            }
        }

        if (index == null) {
            this.additionalLocations = [];
        }
    }

    _getAdditionalLocationById(ID: any): any {

        var index = this._getAdditionalLocationIndexById(ID);
        if (index != -1) {
            return this.additionalLocations[index];
        }
        return null;
    }

    _getAdditionalLocationIndexById(ID: any): any {
        for (var i = 0; i < this.additionalLocations.length; i++) {
            var additionalLocation = this.additionalLocations[i];
            if (additionalLocation.data.locationEntity.ID == ID) {

                return i;
            }
        }

        return -1;
    }

    _setEditReporterVisibility(): void {
        //console.log("_setEditReporterVisibility - iseditor? readonly?", this._isEditor, this.readonly);
        if (this.isExternalEmployee) {
            return;
        }
        if (this._isEditor === true && (this.readonly != true)) {
            domClass.remove(this.btnEditReporter, "w3-hide");
        } else {
            domClass.add(this.btnEditReporter, "w3-hide");
        }
    }

    _setCostCenterVisibility(): void {
        if (this.isExternalEmployee == true) {
            domClass.add(this.sectionCostCenter, "w3-hide");
            /*     domClass.add(this.sectionCostCenter, "w3-hide");
            if (this.isExternalEmployee != true) {
                domClass.remove(this.sectionCostCenter, "w3-hide")*/
        }
    }

    _setDIYvisibility(): void {
        //console.log("_setEditReporterVisibility - iseditor? readonly?", this._isEditor, this.readonly);

        if (this._isEditor === true || !this.entityID && this.is_do_it_yourself) {
            domClass.remove(this.sectionDIY, "w3-hide");
        } else {
            domClass.add(this.sectionDIY, "w3-hide");
        }

        if (this.is_do_it_yourself) {
            domClass.remove(this.infoDIY, "w3-hide");
        } else {
            domClass.add(this.infoDIY, "w3-hide");
        }

        if (this.readonly == true || (this.jsonEntity != null)) {
            domClass.add(this.inputDIY.parentElement, "w3-disabled");
        } else {
            domClass.remove(this.inputDIY, "w3-disabled");
        }
    }

    _setReporterEntity(entity: any): void {
        console.log("_setReporterEntity employee:", entity);
        if (typeof (entity.DispName) == "undefined") {
            entity.DispName = entity.dispname;
        } else if (typeof (entity.dispname) == "undefined") {
            entity.dispname = entity.DispName;
        }
        this.currentReporterEntity = entity;
        this.inputReporter.value = entity.dispname;

        let costCenterEntity = entity.ref_cost_center;
        if ((window as any).occurrenceSubstitution) {
            costCenterEntity = (window as any).occurrenceSubstitution.originalEmployee?.ref_cost_center;
        }

        if (costCenterEntity) {
            this.inputCostCenter.set("value", costCenterEntity);
        }

        this.setPhoneNumbers(entity);
    }

    setPhoneNumbers(rootObject: any): void {
        var bPhone = false;
        domConstruct.empty(this.PhoneNoLabel);
        domConstruct.empty(this.MPhoneNoLabel);
        domClass.add(this.sectionPhoneNo, "w3-hide");
        domClass.add(this.sectionMPhoneNo, "w3-hide");

        if (rootObject.Telephone != null && rootObject.Telephone != "") {
            domClass.remove(this.sectionPhoneNo, "w3-hide");

            domConstruct.create("a", {
                "href": "tel:" + rootObject.Telephone,
                "innerHTML": rootObject.Telephone
            }, this.PhoneNoLabel);
            //domAttr.set(this.PhoneNoLabel, "innerHTML", rootObject.Telephone);
        }
        if (rootObject.Mobile_phone != null && rootObject.Mobile_phone != "") {
            domClass.remove(this.sectionMPhoneNo, "w3-hide");
            domConstruct.create("a", {
                "href": "tel:" + rootObject.Mobile_phone,
                "innerHTML": rootObject.Mobile_phone
            }, this.MPhoneNoLabel);
            //domAttr.set(this.MPhoneNoLabel, "innerHTML", rootObject.Mobile_phone);
        }
    }

    setDate(): void {
        if (this.jsonEntity == null) {
            this.formData.dateOfRecord = new Date();

        } else {
            this.formData.dateOfRecord = new Date(this.jsonEntity.Time);
        }

        var options: any = { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' };
        var stringDateTime = this.formData.dateOfRecord.toLocaleDateString('de-DE', options);
        this.inputDate.value = stringDateTime;
    }

    saveOccurrenceData(callback?: any): void {

        if (this.checkMandatoryFields() != true) {
            this._onSaveOccurrenceDataError(this.translations["OccurrenceAPI_MandatoryPropertyMissing"]);
        }

        if (this.continuousSaveMode != true) {
            this.StandbyStart();
        }

        console.log("saveOccurrenceData", this.formData);

        var url = window.appRoot + "JDM/SaveOccurrenceData";

        this.RequestManager.post(
            url,
            {
                entityID: this.entityID,
                sJsonData: JSON.stringify(this.formData)
            },
            lang.hitch(this, "_onSaveOccurrenceDataResponse", callback),
            lang.hitch(this, "_onSaveOccurrenceDataError"),
            false // sync
        );
    }

    _onSaveOccurrenceDataResponse(callback: any, response?: any): void {

        console.log("_onSaveOccurrenceDataResponse", callback, response);

        // in der response steht eine GUID mit der wir das Entity wiederfinden (keine Entity-ID...)

        // #17314 wenn es weitere Locations gibt, dann in einem zweiten Request diese verarbeiten
        if (this.formData.additionalLocations.length > 0) {
            this._saveAdditionalLocations(this.formData.additionalLocations, response.guid, callback)
            return;
        }

        this.isDirty = false;
        this._formDataUndirty = this.formData;

        if (this.continuousSaveMode != true) {
            this.StandbyStop();
        }

        if (typeof (callback) == "function") { // zb "dialog mit dieser Form schließen und so"
            callback();
        }
    }

    _onSaveOccurrenceDataError(error: any): void {
        if (this.continuousSaveMode != true) {
            this.StandbyStop();
            this.handleErrorResponse(error.Message);
        }

        // auch bei live-Speicherung den Benutzer informieren?
    }

    _saveAdditionalLocations(locations: any, occurrenceGUID: any, callback?: any): void {
        //console.log("_saveAdditionalLocations", locations, occurrenceGUID);

        var data = { sourceOccurrenceGUID: occurrenceGUID, additionalLocations: locations };

        var url = window.appRoot + "Occurrence/CloneToAditionalLocations";

        this.RequestManager.callfunction(
            "Webtool_Occurrence_API__CloneToAdditionalAreas",
            data,
            lang.hitch(this, "_onSaveAdditionalLocationsResponse", callback),
            lang.hitch(this, "_onSaveAdditionalLocationsError"),
            true
        );
    }

    _onSaveAdditionalLocationsError(error: any): void {
        console.error("Zusätzliche Locations wurden nicht gespeichert!!", error.Message);
        if (this.continuousSaveMode != true) {
            this.StandbyStop();
            this.handleErrorResponse("could not save additional locations!<br>" + error.Message);
        }

        // auch bei live-Speicherung den Benutzer informieren?
    }

    _onSaveAdditionalLocationsResponse(callback: any, response?: any): void {

        console.log("_onSaveAdditionalLocationsResponse", callback, response);

        this.isDirty = false;
        this._formDataUndirty = this.formData;

        if (this.continuousSaveMode != true) {
            this.StandbyStop();
        }

        if (typeof (callback) == "function") { // zb "dialog mit dieser Form schließen und so"
            callback();
        }
    }

    loadOccurrence(entityGUID?: any): void {

        this.StandbyStart();

        var url = window.appRoot + "JDM/LoadOccurrenceJSON";

        if (entityGUID != null && typeof (entityGUID) != "undefined") {
            this.entityGUID = entityGUID;
        }

        var entityGUID = this.entityGUID;

        this.RequestManager.post(
            url,
            {
                occurrenceGUID: entityGUID
            },
            lang.hitch(this, "_onLoadOccurrenceResponse"),
            lang.hitch(this, "_onLoadOccurrenceError"),
            false // sync
        );
    }

    _onLoadOccurrenceResponse(response: any, bVirtual?: any): void {
        //this.StandbyStop();
        if (typeof (response) == "string") {
            this.jsonEntity = JSON.parse(response);
        } else if (typeof (response) == "object") {
            this.jsonEntity = response;
        }

        console.log("_onLoadOccurrenceResponse", this.jsonEntity, bVirtual);

        this.hasUserRole("SKC", lang.hitch(this, this._prepareSKCAddons));


        if (this.jsonEntity == null || typeof (this.jsonEntity) == "undefined") {
            this.StandbyStop();
            alert("requested item does not exist");
            return;
        }

        if (bVirtual != true) {

            this.entityID = this.jsonEntity.ID;

            this.taskList.isExecuter = this._isEditor;

            this.taskList.occurrenceID = this.entityID;
            this.taskList.loadScheduledTaskExecutors();

            this.notesList.occurrenceID = this.entityID;
            this.notesList.occurrence = this.jsonEntity;
            this.notesList.startup(this.jsonEntity.EL_occurrence_note_occurrence);

            //this.commentsList.occurrenceID = this.entityID;
            //this.commentsList.occurrence = this.jsonEntity;
            //this.commentsList.startup(this.jsonEntity.EL_occurrence_comment_occurrence);
            ////this.commentsList.enableNewComment(this.jsonEntity.ref_occurrence_status.is_create_reporter_comment == true);

            this.occurrenceChildList.occurrenceID = this.entityID;
            this.occurrenceChildList.occurrence = this.jsonEntity;
            this.occurrenceChildList.occurrenceForm = this;
            this.occurrenceChildList.startup(this.jsonEntity.EL_Occurrence_main_occurrence);

            //if (this.occurrenceTypesData.length == 0) {
            //    this.occurrenceTypesData = [this.jsonEntity.ref_occurrence_type];
            //    this._setOccurrenceTypeValues();
            //}
        }
        // Bearbeitbar wenn ich der Meldende bin und der Status dies zulässt
        this.set("Readonly", this.jsonEntity.isReadonly); // was auch immer gesetzt ist - einmal ausführen (u.a. wegen Eskalationscheckbox)

        this.setFormData(bVirtual);
        //this.inputOccurrenceType._loadListValues();

        if (bVirtual === true) {
            this.StandbyStop();
            return;
        }

        this.emit("EntityChange", this.jsonEntity);

        this.StandbyStop();
    }

    _onLoadOccurrenceError(error: any): void {
        this.StandbyStop();
        this.handleErrorResponse(error.Message);
    }

    setMainOccurrence(entity?: any): any {
        var actualEntity = null;
        if (typeof (entity) == "undefined") {
            actualEntity = this.jsonEntity.ref_main_occurrence;
        } else {
            actualEntity = entity;
        }

        this.mainOccurrence = actualEntity;
        //console.log("setMainOccurrence", actualEntity);
        if (actualEntity == null || typeof (actualEntity) == "undefined") {
            domClass.add(this.sectionMainOccurrence, "w3-hide");
            return;
        }

        if (actualEntity.ID != "") {
            //domAttr.set(this.linkMainOccurrence, "innerHTML", actualEntity.Number);
            domAttr.set(this.labelMainOccurrence, "innerHTML", actualEntity.Number);
            domClass.remove(this.sectionMainOccurrence, "w3-hide");
        }

        if (!this.entityID) {
            this.inputCostCenter.set("value", actualEntity.ref_cost_center2_reported);
        }

        return actualEntity;
    }


    setFormData(bVirtual?: any): void {
        //console.info("setFormData", this.jsonEntity);

        //// special: die Eskalation darf nur bei vorhandenen Meldungen angezeigt werden und dort wenn erlaubt
        //domClass.remove(this.sectionEscalation, "w3-hide");

        domClass.add(this.sectionEscalation, "w3-hide");
        domClass.add(this.sectionTasks, "w3-hide"); // Aufträge
        domClass.add(this.sectionChilds, "w3-hide"); // Folgemeldungen
        domClass.add(this.sectionFeedback, "w3-hide");
        domClass.add(this.sectionEditorInfo, "w3-hide");
        domClass.add(this.sectionCancellationInfo, "w3-hide");
        domClass.add(this.sectionNotes, "w3-hide");

        if (this.jsonEntity == null) {
            return;
        }

        this.inputReporter.value = this.jsonEntity.ref_reporter.DispName;
        this.currentReporterEntity = this.jsonEntity.ref_reporter;

        this.inputDIY.checked = (this.jsonEntity.is_do_it_yourself === true ? "checked" : "");

        this.setPhoneNumbers(this.jsonEntity.ref_reporter);

        if (typeof (this.jsonEntity.EL_Occurrences_of_source_Occurrence) != "undefined") {
            for (var i = 0; i < this.jsonEntity.EL_Occurrences_of_source_Occurrence.length; i++) {
                var derivedOccurrence = this.jsonEntity.EL_Occurrences_of_source_Occurrence[i];

                this.addLocation(derivedOccurrence.ref_managed_object, derivedOccurrence.ref_managed_object.tmp_label, derivedOccurrence.ID, derivedOccurrence.Number, derivedOccurrence.ref_occurrence_status.Coloration);
            }
        }

        let parameter: any = {};
        try {
            if (this.inputOccurrenceType.requestUrlParameter) {
                parameter = JSON.parse(this.inputOccurrenceType.requestUrlParameter);
            }
        } catch (ex) {

        }

        if (bVirtual != true) {

            domClass.remove(this.sectionTasks, "w3-hide"); // Aufträge
            domClass.remove(this.sectionChilds, "w3-hide"); // Folgemeldungen
            domClass.remove(this.sectionFeedback, "w3-hide");
            domClass.remove(this.sectionNotes, "w3-hide");
            //domClass.add(this.btnSendNote, "w3-hide");

            this.inputEscalation.checked = (this.jsonEntity.is_escalation === true ? "checked" : "");
            //if (this.jsonEntity.canEscalate == true || this.jsonEntity.is_escalation === true) {
            //    domClass.remove(this.sectionEscalation, "w3-hide");
            //}

            if (this.jsonEntity.isExecuter == true) {
                domClass.remove(this.sectionEditorInfo, "w3-hide");
                domClass.remove(this.sectionNotes, "w3-hide");
                //domClass.remove(this.btnSendNote, "w3-hide");
            }

            if (this.jsonEntity.is_cancellation_requested == true) {
                domClass.remove(this.sectionCancellationInfo, "w3-hide");
            }

            var mainOcc = this.setMainOccurrence();

            var date = new Date(this.jsonEntity.Time);
            var options: any = { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' };
            this.inputDate.value = date.toLocaleDateString('de-DE', options);

            this.inputFeedback.value = this.jsonEntity.feedback;

            //this.inputOccurrenceType.selectedValue = this.jsonEntity.ref_occurrence_type.ID; // das führt allerdings zu einem change-Event!

            // ID mitgeben, damit die API auf jeden Fall die bereits ausgewählte Meldungsart mitliefert:
            parameter.occurrenceID = this.entityID;


            if (mainOcc != null) {
                // wenns eine Hauptmeldung gibt, dann muss der API das mitgeteilt werden, weil evtl zusätzliche Meldungsarten daherkommen
                parameter.mainOccurrenceID = mainOcc.ID;
            }


        }

        this.inputOccurrenceType.requestUrlParameterValue = JSON.stringify(parameter);


        if (this.jsonEntity.ref_cost_center2_reported != null) {
            if (this.jsonEntity.ref_cost_center2_reported.ID != "") {
                this.inputCostCenter.set("value", this.jsonEntity.ref_cost_center2_reported, true);
            }
            if (this.jsonEntity.ref_cost_center2_reported.ref_employee != null && typeof (this.jsonEntity.ref_cost_center2_reported.ref_employee.ID) != "undefined") {
                //this.inputCostCenterEmployee.value = this.jsonEntity.ref_cost_center2.ref_employee.DispName;
                if (this.jsonEntity.ref_cost_center2_reported.verantwortlich) {
                    this.inputCostCenterEmployee.value = this.jsonEntity.ref_cost_center2_reported.verantwortlich;
                }
            }
        }


        this.inputComment.value = this.jsonEntity.note;//.replace("\r\n", "<br>");

        this.inputOccurrenceType._loadListValues(this.jsonEntity.ref_occurrence_type, true);
        this.setSpecialInfoByOccurrenceType(this.jsonEntity.ref_occurrence_type);
        this.set("AreaNeeded", this.jsonEntity.ref_occurrence_type.is_show_area_info === true ? this.jsonEntity.ref_occurrence_type.area_level : false);
        //this.adjustRoomSelectionState();

        var label = "";
        var selectedBuildingID = null;
        var selectedBPID = null;
        var selectedLevelID = null;
        var selectedRoomID = null;

        let building = null;

        switch (this.jsonEntity.ref_managed_object.Classname) {

            case "Building":
                //label = this.jsonEntity.ref_managed_object.ref_real_estate.OKS_site + " " + this.jsonEntity.ref_managed_object.Name_number
                label = this.jsonEntity.ref_managed_object.dispname;
                selectedBuildingID = this.jsonEntity.ref_managed_object.ID;
                building = this.jsonEntity.ref_managed_object;
                break;

            case "Building_part":
                //label = this.jsonEntity.ref_managed_object.OKS_buildingpart;
                label = this.jsonEntity.ref_managed_object.dispname;
                //selectedBPID = this.jsonEntity.ref_managed_object.ID;
                selectedBuildingID = this.jsonEntity.ref_managed_object.ref_building.ID;
                building = this.jsonEntity.ref_managed_object.ref_building;
                break;

            case "Level":
                //label = this.jsonEntity.ref_managed_object.OKS_level;
                //label = this.jsonEntity.ref_managed_object.ref_building.ref_real_estate.Name_number + " " + this.jsonEntity.ref_managed_object.ref_level_designation.Name;
                label = this.jsonEntity.ref_managed_object.dispname;
                selectedLevelID = this.jsonEntity.ref_managed_object.ID;
                //selectedBPID = this.jsonEntity.ref_managed_object.ref_building_part.ID;
                selectedBuildingID = this.jsonEntity.ref_managed_object.ref_building.ID;
                building = this.jsonEntity.ref_managed_object.ref_building;

                break;

            case "Room":
                //label = this.jsonEntity.ref_managed_object.OKS_room;
                //label = this.jsonEntity.ref_managed_object.Name_number + " (" + this.jsonEntity.ref_managed_object.OKS_room + ")";
                label = this.jsonEntity.ref_managed_object.dispname;
                selectedRoomID = this.jsonEntity.ref_managed_object.ID;
                selectedLevelID = this.jsonEntity.ref_managed_object.ref_level.ID;
                //selectedBPID = this.jsonEntity.ref_managed_object.ref_level.ref_building_part.ID;
                selectedBuildingID = this.jsonEntity.ref_managed_object.ref_level.ref_building.ID;
                building = this.jsonEntity.ref_managed_object.ref_level.ref_building;

                break;


            default:
                label = "???";
                break;

        }
        let ccLabel = "";
        if (building && building.ref_building_cost_center && building.ref_building_cost_center.dispname) {
            ccLabel = building.ref_building_cost_center.dispname;

            if (building.ref_building_cost_center.verantwortlich) {
                ccLabel += " - " + building.ref_building_cost_center.verantwortlich;
            }
        }
        //console.log("setFormData Roomlabel", label, this.jsonEntity.ref_managed_object);
        this.onSelectRoom(1, {
            building: selectedBuildingID,
            buildingpart: selectedBPID,
            level: selectedLevelID,
            room: selectedRoomID,
            _label: label,
            costCenterLabel: ccLabel
        });

        this._renderPropertiesTable(this.jsonEntity.EL_property_occurence_assignment_occurrence);



        if (bVirtual === true) {
            this.jsonEntity = null;
            this.entityID = null;

            this.serializeData();
        }

        else {
            this.serializeData(true); // "nicht dirty" setzen
        }

        this.startupState = "ready";
    }

    loadPropertyList(): void {

        this.StandbyStart(this.sectionProperties);

        var url = window.appRoot + "JDM/LoadOccurrencePropertiesJSON";

        var targetID = null;

        // bei einer neuen Meldung muss die Liste aus dem angegebenen Meldungstyp geladen werden

        if (!this.jsonEntity) {
            targetID = this.formData.occurrenceTypeID;
        }

        // bei einer bestehenden Meldung kommt die Liste direkt aus der Meldung
        else {
            targetID = this.jsonEntity.ID;
        }

        this.RequestManager.post(
            url,
            {
                targetID: targetID
            },
            lang.hitch(this, "_onLoadPropertyListResponse"),
            lang.hitch(this, "_onLoadPropertyListError"),
            false // sync
        );
    }

    _onLoadPropertyListResponse(response: any): void {
        this.StandbyStop();
        var entitylist = response;
        //console.log("_onLoadPropertyListResponse", entitylist);
        this._renderPropertiesTable(entitylist);
    }

    _onChangeProperties(data?: any): void {
        //console.log("_onChangeProperties", data);
        this.serializeData();
    }

    _onLoadPropertyListError(error: any): void {
        this.StandbyStop();
        this.handleErrorResponse(error.Message);
        //alert(error.Message);
    }

    _onChangeOccurenceType(selectedValue?: any): void {
        selectedValue = this.inputOccurrenceType.getValue();
        console.log("_onChangeOccurenceType", selectedValue, this.inputOccurrenceType.entities, this._parentRoomSelection);
        this._setAdditionalLocationsVisibility(selectedValue);
        this.is_do_it_yourself = selectedValue ? selectedValue.is_do_it_yourself === true : false;
        this.inputDIY.checked = this.is_do_it_yourself;
        this._setDIYvisibility();
        this.removeAdditonalLocation();

        if (selectedValue == "" || selectedValue == null) {
            this.set("AreaNeeded", false);
            return;
        }

        this.serializeData();

        this.loadPropertyList();

        this.setSpecialInfoByOccurrenceType(selectedValue);

        this.set("AreaNeeded", selectedValue.is_show_area_info === true ? selectedValue.area_level : false);

        if (this._parentRoomSelection) {
            this.onSelectRoom(1, this._parentRoomSelection);

            let roomDialog = new RoomDialog();
            roomDialog.extendedData = { "occurrenceType": this.formData.occurrenceTypeID }; // JDM schränkt die auswählbaren Räume und Gebäude nach Meldungsart ein
            roomDialog.selection = this._parentRoomSelection;
            roomDialog.loadBuildings(false, lang.hitch(this, this._loadedBuildingsCallback, roomDialog));



        } else {
            this.onSelectRoom(1, null); // raum zurücksetzen!
        }

    }

    _loadedBuildingsCallback(dlg: any): void {
        let label = dlg.buildSelectionLabel(this.isAreaNeeded);
        this.labelRoom.value = label;
        //console.debug("get label from roomdialog", label);

        dlg.destroy();

    }

    setSpecialInfoByOccurrenceType(occTypeEntity: any): void {
        //console.log("setSpecialInfoByOccurrenceType", occTypeEntity, this.entityID);

        occTypeEntity.is_show_special_note == true || occTypeEntity.is_show_special_confirmation == true ?
            domClass.remove(this.sectionSpecialInfo, "w3-hide") :
            domClass.add(this.sectionSpecialInfo, "w3-hide");

        this.entityID != null ?
            domClass.add(this.sectionSpecialInfo, "w3-disabled") :
            domClass.remove(this.sectionSpecialInfo, "w3-disabled");

        this.setSpecialConfirmation(occTypeEntity.is_show_special_confirmation == true ?
            occTypeEntity.special_confirmation_text : "");
        this.setSpecialNote(occTypeEntity.is_show_special_note == true ?
            occTypeEntity.special_note : "");

    }

    _onChangeComment(): void {
        this.serializeData();
    }

    _onChangeFeedback(): void {
        // feedback derzeit nicht bearbeitbar im Formular
    }

    _onChangeCostCenter(selectedEntity?: any): void {

        console.log("_onChangeCostCenter", selectedEntity);
        if (selectedEntity) {
            //this.inputCostCenterEmployee.value = selectedEntity.ref_employee.DispName;
            if (selectedEntity.verantwortlich) {
                this.inputCostCenterEmployee.value = selectedEntity.verantwortlich;
            }
        } else {
            this.inputCostCenterEmployee.value = null;
        }
        this.serializeData();
    }

    _onClick_EditReporter(evt?: any): void {
        if (this._isEditor != true || this.readonly == true) { // Rechteprüfung!
            return;
        }

        this.showEditReporter();
    }

    setSpecialNote(text?: any): void {
        if (text == "" || text == null || typeof (text) == "undefined") {
            text = "";
            domClass.add(this.tableSpecialNote, "w3-hide");
        } else {
            domClass.remove(this.tableSpecialNote, "w3-hide");
        }

        domAttr.set(this.txtSpecialNote, "innerHTML", text);
    }

    setSpecialConfirmation(text?: any): void {
        if (text == "" || text == null || typeof (text) == "undefined") {
            text = "";
            this.isSpecialConfirmationNeeded = false;
            domClass.add(this.tableSpecialConfirmation, "w3-hide");
        } else {
            domClass.remove(this.tableSpecialConfirmation, "w3-hide");
            this.isSpecialConfirmationNeeded = true;
        }

        this.setSpecialConfirmationStatus(this.entityID != null);

        domAttr.set(this.txtSpecialConfirmation, "innerHTML", text);
    }

    _onClick_SpecialConfirmation(evt?: any): void {

        if (this.isSpecialConfirmationNeeded != true || this.readonly === true) {
            return;
        }

        //console.debug("_onClick_SpecialConfirmation", this._specialConfirmationStatus);
        this.setSpecialConfirmationStatus(this._specialConfirmationStatus !== true);
    }

    setSpecialConfirmationStatus(targetState?: any): void {
        this._specialConfirmationStatus = targetState;
        //console.debug("setSpecialConfirmationStatus", targetState);

        this.serializeData();

        this.setSpecialConfirmationStatusStyle();
    }

    setSpecialConfirmationStatusStyle(): void {
        domClass.toggle(this.tableSpecialConfirmation, "mds-hover-dark", !this.readonly);

        domClass.toggle(this.tableSpecialConfirmation, "checked", this._specialConfirmationStatus);
        domClass.toggle(this.buttonCheckSpecialConfirmation_Unchecked, "w3-hide", this._specialConfirmationStatus);
        domClass.toggle(this.buttonCheckSpecialConfirmation_Checked, "w3-hide", !this._specialConfirmationStatus);

    }

    showEditReporter(bShow?: any): void {

        this._enableChangeReporter = false;

        if (bShow === false) {
            this._tmpSelectedReporterEntity = null;

            if (this._tmpReporterHintbox != null) {
                this._tmpReporterHintbox.destroy();
                this._tmpReporterHintbox = null;
                domConstruct.empty(this.editReporterContainer);

                domClass.add(this.editReporterContainer, "w3-hide");
                domClass.remove(this.inputReporter, "w3-hide");
                domClass.remove(this.btnEditReporter, "w3-hide");
                domClass.add(this.btnConfirmReporter, "w3-hide");
                domClass.add(this.btnCancelReporter, "w3-hide");
                //domClass.remove(this.sectionPhoneNo, "w3-hide");
                //domClass.remove(this.sectionMPhoneNo, "w3-hide");
            }
        } else {
            domClass.add(this.sectionPhoneNo, "w3-hide");
            domClass.add(this.sectionMPhoneNo, "w3-hide");
            domClass.remove(this.editReporterContainer, "w3-hide");
            domClass.add(this.inputReporter, "w3-hide");
            domClass.add(this.btnEditReporter, "w3-hide");
            //domClass.remove(this.btnConfirmReporter, "w3-hide");
            domClass.remove(this.btnCancelReporter, "w3-hide");

            var reporterHintbox: any = new HintBox();

            reporterHintbox.set("DataFormat", "json"); // wird für Request und Response benötigt (pithelper)
            reporterHintbox.labelAttribute = "DispName";
            //reportHintbox.suggestionLabelAttribute = null;
            //reportHintbox.filterPath = null;
            //reportHintbox.searchParam = null; // name des Parameters im Filter ( => pit-Filter)
            reporterHintbox.requestUrlSearchParameter = "searchText"; // name des Parameters der über die Url als Http-Request gesendet wird (=> Controller)
            reporterHintbox.resetOnEdit = false; // das Entity zurücksetzen wenn der Benutzer eine Eingabe macht (also Inputfeld irgendwie reintippt)

            reporterHintbox.url = "JDM/GetPotentialOccurrenceReporters";
            reporterHintbox.minLetterCount = 3;

            reporterHintbox.limit = 15;

            reporterHintbox.readonly = false;

            reporterHintbox.set("value", this.currentReporterEntity);

            domConstruct.place(reporterHintbox.domNode, this.editReporterContainer);

            this._tmpReporterHintbox = reporterHintbox;

            on(reporterHintbox, "change", lang.hitch(this, this.continueEditReporter));

            reporterHintbox.input.focus();
        }
    }

    continueEditReporter(data?: any): void {
        console.log("continueEditReporter", data);

        this._tmpSelectedReporterEntity = data;

        // BYPASS (ZAL will die Bestätigungsbuttons nicht):
        if (this._tmpSelectedReporterEntity != null) {
            this._onClickConfirmEditReporter();
        }
        return;

        if (this._tmpSelectedReporterEntity != null) {
            domClass.remove(this.btnConfirmReporter, "w3-disabled");
            domClass.add(this.btnConfirmReporter, "mds-hover-dark");
            //domClass.remove(this.btnCancelReporter, "w3-disabled");
            //domClass.add(this.btnCancelReporter, "mds-hover-dark");
            this._enableChangeReporter = true;
        } else {
            domClass.add(this.btnConfirmReporter, "w3-disabled");
            domClass.remove(this.btnConfirmReporter, "mds-hover-dark");
            //domClass.add(this.btnCancelReporter, "w3-disabled");
            //domClass.remove(this.btnCancelReporter, "mds-hover-dark");
            this._enableChangeReporter = false;
        }
    }

    _onClickConfirmEditReporter(evt?: any): void {

        if (this._tmpSelectedReporterEntity != null) {
            if (this._tmpSelectedReporterEntity.ID != this.currentReporterEntity.ID) {
                this._setReporterEntity(this._tmpSelectedReporterEntity);
            }
        }

        this.showEditReporter(false);

        this.serializeData(false, true);
    }

    _onClickCancelEditReporter(evt?: any): void {
        this.showEditReporter(false);

        this._setReporterEntity(this.currentReporterEntity);
    }

    _onClick_MainOccurrence(evt: any): void {
        evt.stopPropagation();
        var occHome = (document as any).occurrenceHome;
        var dlg = occHome.showOccurrenceDialog(this.mainOccurrence.web_guid, true); // ID, readonly
    }

    _onClick_SelectRoom(evt?: any): void {
        this.selectRoom();
    }

    selectRoom(): void {
        var roomDialog = new RoomDialog();
        roomDialog.set("callback", lang.hitch(this, "onSelectRoom"));
        roomDialog.extendedData = { "occurrenceType": this.formData.occurrenceTypeID }; // JDM schränkt die auswählbaren Räume und Gebäude nach Meldungsart ein

        //console.log("select room, set data", this.formData);
        roomDialog.selection.level = this.formData.levelID;
        roomDialog.selection.building = this.formData.buildingID;
        roomDialog.selection.buildingpart = this.formData.buildingPartID;
        roomDialog.selection.room = this.formData.roomID;
        //console.log("select room, data is set", roomDialog.selection);

        roomDialog.set("NeededLayers", this.isAreaNeeded)

        roomDialog.setEmployee(this.employee);

        roomDialog.set("ok", true);
        roomDialog.set("cancel", true);
        roomDialog.set("header", /*"Raum bearbeiten"*/this.translations["SelectRoomDialog__Header"]);

        roomDialog.show();
    }

    onSelectRoom(result?: any, selection?: any): void {
        console.info("onSelectRoom", result, selection);

        if (result != 1) {
            return;
        }

        var label = "";

        if (selection == null || typeof (selection) == "undefined") {
            this.selectedBuildingID = null;
            this.selectedBuildingPartID = null;
            this.selectedLevelID = null;
            this.selectedRoomID = null;


        } else {

            this.selectedBuildingID = selection.building;
            this.selectedBuildingPartID = selection.buildingpart;
            this.selectedLevelID = selection.level;
            this.selectedRoomID = selection.room;

            label = selection._label;

            if (selection.costCenterLabel) {
                domClass.remove(this.buildingCostCenterContainer, "w3-hide");
                domAttr.set(this.txtBuildingCostCenter, "innerHTML", selection.costCenterLabel);
            } else {
                domClass.add(this.buildingCostCenterContainer, "w3-hide");
            }
        }

        domAttr.set(this.labelRoom, "value", label);

        this.adjustRoomSelectionState();

        if (this.startupState == "ready") {
            this.serializeData();
        }
    }

    _onChangeDIY(evt?: any): void {
        if (this.readonly != true) {
            this.serializeData();
        } else {
            this.inputDIY.checked = this.jsonEntity.is_do_it_yourself == true ? "checked" : "";
        }
    }

    _onChangeEscalation(evt?: any): void {
        this.serializeData();

        // wegen schreibschutz wird das entity aber nicht dirty, daher manuell:
        if (this.readonly == true) {

            if (this._formDataUndirty != null) {
                this.set("IsDirty", this._formDataUndirty != JSON.stringify(this.formData));
            } else {
                this.set("IsDirty", this._formDataUndirty == null && this.formData != null);
            }

            //console.log("changed escalation - dirty?", this.formData, this._formDataUndirty, this.isDirty);
        }
    }

    _onChanged_TaskExecuters(): void {
        this.loadOccurrence();
        //this.jsonEntity.isExecuter = true;
        //this.occurrenceChildList.startup(); // -> Liste neu laden und der Folgemeldung-Button einblenden
        //this.commentsList.startup();
    }

    _setAreaNeededAttr(value?: any): void {
        this.isAreaNeeded = value;
        //console.log("area needed?", value);
        if (this.isAreaNeeded !== false) {
            domClass.remove(this.sectionArea, "w3-hide");
        } else {
            domClass.add(this.sectionArea, "w3-hide");

            this.formData.selectedBuildingID = null;
            this.formData.selectedBuildingPartID = null;
            this.formData.selectedLevelID = null;
            this.formData.selectedRoomID = null;
        }
    }

    _setIsDirtyAttr(value?: any): void {
        //console.log("set dirty", value);
        if (this.isDirty != value) {
            this.emit("DirtyStateChange", value);
            this.isDirty = value;
        }
    }

    adjustRoomSelectionState(): void {
        console.log("adjustRoomSelectionState - area needed?", this.isAreaNeeded);

        if (this.isAreaNeeded < 3) {
            this.selectedRoomID = null;
        }

        if (this.isAreaNeeded < 2) {
            this.selectedLevelID = null;
        }

        if (this.isAreaNeeded < 1) {
            this.selectedBuildingPartID = null;
        }

        if (this.isAreaNeeded === false) {
            this.selectedRoomID = null;
            this.selectedLevelID = null;
            this.selectedBuildingPartID = null;
            this.selectedBuildingID = null;
        }

        if ((this.selectedBuildingID == null && this.isAreaNeeded >= 0)
            //|| (this.selectedBuildingPartID == null && this.isAreaNeeded >= 1)
            || (this.selectedLevelID == null && this.isAreaNeeded >= 2)
            || (this.selectedRoomID == null && this.isAreaNeeded >= 3)) {
            domClass.add(this.containerRoom, "w3-border-red w3-pale-red")
        }

        else {
            domClass.remove(this.containerRoom, "w3-border-red w3-pale-red")
        }
    }

    _renderPropertiesTable(propertyList?: any): void {

        this.propertiesTable.isReadonly = this.readonly === true;
        this.propertiesTable.set("data", propertyList); // NEUE TABLLE 2021!!

        //console.log("_renderPropertiesTable", this.readonly, propertyList, this.propertiesTable);

        domConstruct.empty(this.propertiesContainer);

        if (propertyList == null || typeof (propertyList) == "undefined") {
            domClass.add(this.sectionProperties, "w3-disabled");
            return;
        }

        domClass.remove(this.sectionProperties, "w3-disabled");
    }


    handleErrorResponse(message?: any): void {
        if (typeof (this.errorCallback) == "function") {
            this.errorCallback(message);
            return;
        }

        // ansonsten Fehlermeldung selber irgendwo platzieren?
        //alert(error.Message);
    }

    handleSuccessResponse(): void {
        if (typeof (this.successCallback) == "function") {
            this.successCallback();
            return;
        }
    }

    showComment(commentId: any): void {
        this.commentsList.requestComment(commentId);
    }

    _onSetPropertyValueResponse(response?: any): void {
        //console.log("_onSetPropertyValueResponse", response);
    }

    _onSetPropertyValueError(error: any): void {
        console.error("_onSetPropertyValueError", error);
    }

}
OccurrenceForm.prototype.declaredClass = 'WidgetCollection.Occurrence.OccurrenceForm';

export default mdsWidget(OccurrenceForm);
